import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import {
  ActivityFragment,
  ChangeSetFragment,
} from '@spotify/confidence-graphql';

export interface ActivityChangeOptions {
  activity: ActivityFragment;
  change: ChangeSetFragment['changes'][number];
}

export interface ActivityChangeExtensionOptions
  extends ItemRenderExtensionOptions<ActivityChangeOptions> {
  title?: (change: ChangeSetFragment['changes'][number]) => string;
}

export const createActivityChangeExtensions = (id: string) => {
  return createItemRenderExtensions({
    id,
  });
};

export const useActivityChangeExtensions = (
  extensions: ReturnType<typeof createActivityChangeExtensions>,
): ActivityChangeExtensionOptions[] => {
  return useItemRenderExtensions<ActivityChangeExtensionOptions>(extensions);
};

export const createActivityChangeExtension = (
  options: ActivityChangeExtensionOptions,
) => {
  return createItemRenderExtension<ActivityChangeExtensionOptions>(options);
};
